import { Suspense, lazy } from 'react';
import { Dialog, Typography } from '@mui/material';
import { Header } from 'ui/Header/Header';
import PDFViewerErrorBoundary from 'common/PSPDFKit/PDFViewerErrorBoundary';

type Props = {
  url: string;
  fileName: string;
  open: boolean;
  headerTitle: string;
  onClose: () => void;
};

const PSPDFViewer = lazy(() => import('common/PSPDFKit/PSPDFViewer'));

const pdfViewerFallbackStyle: React.CSSProperties = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
};

const pdfViewerFallback = (
  <div
    role="status"
    aria-label="Loading PDF viewer"
    style={pdfViewerFallbackStyle}
  >
    Loading PDF viewer...
  </div>
);

export default function FileDisplayFromUrl({
  url,
  open,
  headerTitle,
  fileName,
  onClose,
}: Props) {
  const isPdf = url.split('?')[0]?.endsWith('.pdf');

  return (
    <Dialog
      open={open}
      fullScreen
      PaperProps={{ sx: { width: 'calc(100vw - 200px)' } }}
      sx={{ zIndex: 1049 }}
      maxWidth="xl"
    >
      <Header onClose={onClose} title={headerTitle} />
      {open && url && isPdf && (
        <PDFViewerErrorBoundary key={url}>
          <Suspense fallback={pdfViewerFallback}>
            <PSPDFViewer url={url} fileName={fileName} />
          </Suspense>
        </PDFViewerErrorBoundary>
      )}
      {url && !isPdf && (
        <iframe title="preview" src={url} width="100%" height="1000px" />
      )}
      {!url && (
        <Typography
          variant="h1"
          color="GrayText"
          display="flex"
          paddingTop="2rem"
          justifyContent="center"
        >
          Preview unavailable
        </Typography>
      )}
    </Dialog>
  );
}
